import React from "react";
import "../App.css";
import { useTranslation } from "react-i18next";

export default function Video3() {
  const { t } = useTranslation();
  return (
    <div className="ow-video-wrap">
      <div className="ow-video-frame ow-video-frame-ratio">
        <iframe
          src="https://www.youtube.com/embed/QXQ4VX9Eq6M"
          title="Wajdi Bouallègue's routine at the Moscow World Cup 2007"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <p className="ow-video-caption">{t("routine3")}</p>
    </div>
  );
}
